import { createSelector } from 'reselect'

import { selectFinancialCockpitState } from './selectFinancialCockpitState'

export const selectCockpitFilterPbm = createSelector(
  [selectFinancialCockpitState],
  ({ filter }) => filter.pbm
)
